<template>
    <div>
        <b-tab no-body :title="$tc('message.consultations',2)" :active="pathHas('generale') || pathHas('obstetric') || pathHas('cardiologie')">
            <b-row>
                <b-col sm="4">
                    <b-dropdown id="dropdown-left" :text="$tc('message.addConsultation')" variant="primary" class="m-2" v-if="hasAdminRole ||  hasPraticienRole || hasMedecinControleRole || hasAssistante">
                        <b-dropdown-item :to="{ name: 'add-consultation-general' , params: { file: this.file_id } }">{{$t('message.general')}}</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'add-consultation-cardiology' , params: { file: this.file_id } }">{{$t('message.cardiology')}}</b-dropdown-item>
                        <!-- <b-dropdown-item :to="{ name: 'add-consultation-kinesitherapie' , params: { file: this.file_id } }">{{$t('message.kinesitherapie')}}</b-dropdown-item>
                        <b-dropdown-item v-if="isFemale" :to="{ name: 'add-consultation-obstetric', params: { file: this.file_id } }">{{$t('message.obstetric')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.dermatology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.endocrinology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.gastroenterology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.geriatrics')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.hématologie')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.nephrology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.neurology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.ophthalmology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.oncology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.earNoseThroat')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.pediatrics')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.pneumology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.psychiatry')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.rheumatology')}}</b-dropdown-item>
                        <b-dropdown-item href="#">{{$t('message.stomatology')}}</b-dropdown-item> -->
                        <b-dropdown-item href="#" @click="OpenTeleconsultation">{{$t('message.tele')}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>

                <b-col sm="4"></b-col>
            </b-row>
            <div id="generale" v-if="notEmpty(medecinesRows)">
                <h3 class="text-center"> {{ $tc('message.generalConsultations', 1) }} </h3>
                <div>
                    <!-- <div id="table-demo" v-if="mobileView">
                        <table class="with-header row-clickable">
                            <tr>
                                <th class="new-title" v-for="(row, x) in medecinesColumns" :key="x"> {{row.label}} </th>
                            </tr>
                            
                            <tr v-for="(col, x) in medecinesRows" :key="x" class="clickable-row">
                                <td> <span class="new-title"> Etablissement: </span><p> {{col.etablissement}} </p></td>
                                <td> <span class="new-title"> Praticien: </span> {{col.consultant}} </td>
                                <td> <span class="new-title"> Date: </span> {{col.date}} </td>
                                <td> <span class="new-title"> Motifs: </span> {{col.motifs}} </td>
                                <td> <span class="new-title"> Dianostic: </span> {{col.conclusions}} </td>
                                <td> <span class="new-title"> Conduite a tenir: </span> <div v-html="col.traitement"></div> </td>
                            </tr>
                            
                        </table>
                    </div> -->
                    <vue-good-table v-if="notEmpty(medecinesRows) && !mobileView" id="medecine" :columns="medecinesColumns" :rows="medecinesRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onMedecineRowClick"> <!--  -->
                        <!-- <template slot="table-row" slot-scope="props" > -->
                            <!-- <span v-if="props.column.field == 'visualiser'"> -->
                                <!-- <b-button v-if="props.column.field == 'visualiser'" variant="outline-success" class="border-0" @click="ConsultationVisuel(props.row.slug)">
                                    <i class="fas fa-eye" width="30"></i>
                                    {{ $tc('message.visualiser') }}
                                </b-button> -->
                                
                            <!-- </span> -->
                        <!-- </template>  -->
                    </vue-good-table>

                    <div id="table-demo" v-if="mobileView"> <!-- && !mobileView -->
                        <div class="ltemp--content--box border border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white" v-for="(row, x) in medecinesRows" :key="x"  @click="onMedecineRowClickMobile(row.slug)">
                            <div class="trajet__info bg-white mt-2 px-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                                <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                    <span class="d-flex align-items-center text-gray">
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                        <span class="px-1">{{row.date}}</span>
                                    </span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default text-gray"> {{row.motifs}} </span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default d-none d-md-block">{{row.etablissement}}</span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default d-none d-md-block">{{row.consultant}}</span>
                                    <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="">
                                        <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onMedecineRowClickMobile(row.slug) "><!-- :to="{ name: 'consultation-general' , params: { file: this.$route.params.file } }" -->
                                            <span class="d-none d-md-block">Voir</span>
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </b-button> 
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="obstetric" v-if="isFemale && notEmpty(obstetricsRows)">
                <h3 class="text-center"> {{ $tc('message.obstetricConsultations', 1) }}</h3>
                <b-card-body>
                    <vue-good-table v-if="notEmpty(obstetricsRows)" :columns="obstetricsColumns" :rows="obstetricsRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onObsteticRowClick" />
                </b-card-body>
            </div>

            <div id="cardiologie" v-if="notEmpty(cardiologiesRows)">
                <h3 class="text-center"> {{ $t('message.cardiologyConsultations') }}</h3>
                <b-card-body>

                    <vue-good-table v-if="notEmpty(cardiologiesRows)" id="cardiologie_consultation" :columns="cardiologiesColumns" :rows="cardiologiesRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onCardiologyRowClick" />
                </b-card-body>
            </div>
            <div id="kinesitherapie" v-if="notEmpty(kinesitherapiesRows)">
                <h3 class="text-center"> {{ $t('message.kinesitherapyConsultations') }}</h3>
                <b-card-body>

                    <vue-good-table v-if="notEmpty(kinesitherapiesRows)" id="kinesitherapie_consultation" :columns="kinesitherapiesColumns" :rows="kinesitherapiesRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onkinesitherapyRowClick" />
                </b-card-body>
            </div>

            <div class="row" v-if="teleconsultations.data">
                <h3 class="text-center mt-5"> {{ $t('message.tele') }}</h3>
                <div class="">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Etablissement</th>
                                <th>Praticien</th>
                                <th>Date</th>
                                <th>Motif</th>
                                <th>CAT</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(teleconsultation, index) in teleconsultations.data.data" :key="'teleconsultation'+index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ teleconsultation.etablissements.length > 0 ? teleconsultation.etablissements[0].name : "" }}</td>
                                <td>{{ teleconsultation.medecin.length > 0 ? teleconsultation.medecin[0].name : "" }}</td>
                                <td>{{ teleconsultation.created_at }}</td>
                                <td>
                                    <ol>
                                        <li v-for="(motif, index) in teleconsultation.motifs" :key="'motif'+index" v-html="motif.description"></li>
                                    </ol>
                                </td>
                                <td v-html="teleconsultation.cat"></td>
                                <td>
                                    <b-button variant="outline-success" class="border-0" @click="printTeleconsultation(teleconsultation.pdf)">
                                        <i class="fa fa-print"></i>
                                        Impriner
                                    </b-button>
                                    <!-- <button type="button" @click="printTeleconsultation(teleconsultation.pdf)" class="btn btn-light"><i class="fa fa-print"></i><span>Impriner</span></button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-tab>
    </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import AppConfig from '../../constants/AppConfig';
export default {
    name: "Consultation",
    components: {
        VueGoodTable,
    },
    computed: {
         ...mapGetters(["file", "teleconsultations"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
         mConsultationsMedecine: function () {
            return (typeof this.mMedicalFile.consultations_medecine == "object" ? this.mMedicalFile.consultations_medecine : []);
        },
        medecinesRows: function () {
            let self = this;
            let mArray = [];
            _.forEach(_.orderBy(self.mConsultationsMedecine, ['created_at'], ['desc']), function (consultation) {
                let motifs = "";
                let conclusions = "";
                let etablissement = "";

                if (consultation.hasOwnProperty('motifs')) {
                    _.forEach(consultation.motifs, function (motif, key) {
                        motifs = motifs + ((key != consultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }

                if (consultation.hasOwnProperty('conclusions')) {
                    _.forEach(consultation.conclusions, function (conclusion) {
                        conclusions += " " + conclusion.description;
                    });

                    if (conclusions.length > 105) {
                        conclusions = conclusions.substring(0, 105) + " ...";
                    }
                }

                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }

                let traitement = "";
                if (!_.isNull(consultation.traitement_propose)) {
                    if (consultation.traitement_propose.length > 105) {
                        traitement = consultation.traitement_propose.substring(0, 105) + " ...";
                    } else {
                        traitement = consultation.traitement_propose;
                    }
                }

                mArray.push({
                    date: consultation.date_consultation,
                    motifs: motifs,
                    conclusions: conclusions,
                    etablissement: etablissement,
                    traitement: traitement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                });
            });
            let sArray = mArray;
            mArray = self.filterResult(sArray, mArray);
            return mArray;
        },
        obstetricsRows: function () {
            let oArray = [];
            let self = this;
            _.forEach(this.mConsultationsObstetrique, function (consultation) {
                let etablissement = "";
                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }
                oArray.push({
                    numero: consultation.numero_grossesse,
                    date: consultation.ddr,
                    serologie: consultation.serologie,
                    groupe: consultation.groupe_sanguin,
                    etablissement: etablissement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                })
            });

            let sArray = oArray;
            oArray = self.filterResult(sArray, oArray);
            return oArray;
        },
        kinesitherapiesRows: function () {
            let kArray = [];

            let self = this;

            _.forEach(_.orderBy(self.mMedicalFile.kinesitherapies, ['created_at'], ['desc']), function (kinesitherapie) {
                let motifs = "";
                let date = "";
                let diagnostic = "";
                let etablissement = "";
                //console.log(kinesitherapie);
                if (kinesitherapie.hasOwnProperty('motifs')) {
                    _.forEach(kinesitherapie.motifs, function (motif, key) {
                        motifs = motifs + ((key != kinesitherapie.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }
                if (!_.isNull(kinesitherapie.etablissement_id)) {
                    if (kinesitherapie.hasOwnProperty('etablissement')) {
                        if (!_.isNull(kinesitherapie.etablissement)) {
                            etablissement = kinesitherapie.etablissement.name;
                        } else {
                            etablissement = kinesitherapie.etablissement_id;
                        }
                    }
                }

                date = kinesitherapie.date_consultation;
                if (!_.isNull(kinesitherapie.impression_diagnostique)) {
                    diagnostic = (kinesitherapie.impression_diagnostique.length > 105) ? kinesitherapie.impression_diagnostique.substring(0, 105) + " ..." : kinesitherapie.impression_diagnostique;
                }

                kArray.push({
                    date: date,
                    motifs: motifs,
                    conclusions: diagnostic,
                    etablissement: etablissement,
                    slug: kinesitherapie.slug,
                    consultant: self.formatFullName(kinesitherapie.author),
                    passedAt: kinesitherapie.passed_at,
                    archievedAt: kinesitherapie.archieved_at
                });
            });

            let sArray = kArray;
            kArray = self.filterResult(sArray, kArray);
            return kArray;
        },
        cardiologiesRows: function () {
            let cArray = [];

            let self = this;

            _.forEach(_.orderBy(self.mMedicalFile.cardiologies, ['created_at'], ['desc']), function (consultation) {
                let motifs = "";
                let date = "";
                let diagnostic = "";
                let etablissement = "";

                if (consultation.hasOwnProperty('motifs')) {
                    _.forEach(consultation.motifs, function (motif, key) {
                        motifs = motifs + ((key != consultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    if (motifs.length > 105) {
                        motifs = motifs.substring(0, 105) + " ...";
                    }
                }
                if (!_.isNull(consultation.etablissement_id)) {
                    if (consultation.hasOwnProperty('etablissement')) {
                        if (!_.isNull(consultation.etablissement)) {
                            etablissement = consultation.etablissement.name;
                        } else {
                            etablissement = "";
                        }
                    }
                }

                date = consultation.date_consultation;
                if (!_.isNull(consultation.conclusion)) {
                    diagnostic = (consultation.conclusion.length > 105) ? consultation.conclusion.substring(0, 105) + " ..." : consultation.conclusion;
                }

                cArray.push({
                    date: date,
                    motifs: motifs,
                    conclusions: diagnostic,
                    etablissement: etablissement,
                    slug: consultation.slug,
                    consultant: self.formatFullName(consultation.author),
                    passedAt: consultation.passed_at,
                    archievedAt: consultation.archieved_at
                });
            });

            let sArray = cArray;
            cArray = self.filterResult(sArray, cArray);
            return cArray;
        },
        isFemale: function () {
            return this.mMedicalFile.hasOwnProperty('patient') ? this.mMedicalFile.patient.sexe == "F" : false;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView: true,
            medecinesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },

                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
                {
                    label: this.$i18n.t('message.suggestTreatment'),
                    field: 'traitement',
                    html: true
                },
                // {
                //     label: this.$i18n.t('message.visualiser'),
                //     field: 'visualiser',
                //     sortable: false
                // },
            ],
            lineNumbers: Boolean,
            responsive: { default: true , type: Boolean },
            styleClass: { default: 'vgt-table bordered' },
            obstetricsColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.pregnancyNumber'),
                    field: 'numero',
                    type: 'number',
                },
                {
                    label: this.$i18n.t('message.ddr'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.t('message.serology'),
                    field: 'serologie',
                },
                {
                    label: this.$i18n.t('message.bloodGroup'),
                    field: 'groupe',
                },
            ],
            cardiologiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            kinesitherapiesColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'consultant',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
                {
                    label: this.$i18n.tc('message.reasons', 1),
                    field: 'motifs',
                },

                {
                    label: this.$i18n.t('message.conclusion'),
                    field: 'conclusions',
                    html: true
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {

        OpenTeleconsultation(){
            window.location.href =`${AppConfig.teleconsultationUrl}?project=${this.file_id}&slug=${this.file_id}&ms=${localStorage.getItem('ms-token')}`;
        },

        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },

        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        onMedecineRowClickMobile(params) {
            // console.log(params)
            this.$router.push({
                name: 'consultation-general',
                params: {
                    consultation: params
                }
            });
        },

        ConsultationVisuel: slug => {
            // console.log(slug);
            // nono-1657012615-11004975-1657012964
            // nono-1657012615-11004975-1659551124
            axios.get(`${AppConfig.apiUrl}/visualiser-consultation-medecine/${slug}`,
                {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }}
            ).then(res => {
                // console.log(res.data.link);
                window.open(res.data.link, '_blank');
            }).catch(error => {
                console.log('error ', error);
            })
        },

        onMedecineRowClick(params) {
            // console.log(params)
            this.$router.push({
                name: 'consultation-general',
                params: {
                    consultation: params.row.slug
                }
            });
        },

        onCardiologyRowClick(params) {
            this.$router.push({
                name: 'consultation-cardiology',
                params: {
                    consultation: params.row.slug
                }
            });
        },
        onkinesitherapyRowClick(params) {
            //console.log(params);
            this.$router.push({
                name: 'consultation-kinesitherapie',
                params: {
                    kinesitherapie: params.row.slug
                }
            });
        },
        onObsteticRowClick(params) {
            this.$router.push({
                name: 'consultation-obstetric',
                params: {
                    consultation: params.row.slug
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
        formatFullName(author) {
            if (!_.isNull(author) && !_.isUndefined(author)) {
                if (author.hasOwnProperty('user')) {
                    let user = author.user
                    if (!_.isUndefined(user) && !_.isNull(user)) {
                        let prenom = (user.prenom == null) ? '' : user.prenom;
                        return (user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                } else {
                    if (!_.isUndefined(author) && !_.isNull(author)) {
                        let prenom = (author.prenom == null) ? '' : author.prenom;
                        return (author.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    }
                }
            }
            return "";
        },
        filterResult(sArray, mArray) {
            if (this.filteredValue == 1) {
                mArray = sArray;
            } else if (this.filteredValue == 2) {
                //Non archivés
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 3) {
                //Non transmis
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.passedAt);
                })
            } else if (this.filteredValue == 4) {
                //Archivés
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 5) {
                //Transmis
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.passedAt);
                })
            }
            return mArray;
        },
        getTeleconsultations(page = 1) {
            let args = {
                page: 1,
                page_size: 10,
                patient_id: localStorage.getItem('dossier_medical_slug')
            };

            this.$store.dispatch("getTeleconsultations", { args });
        },
        previous(page){
            page--
            this.getTeleconsultations(page, 10);
        },
        next(page){
            page++
            this.getTeleconsultations(page, 10);
        },
        changePage(page){
            this.getTeleconsultations(page, 10);
        },
        printTeleconsultation(pdf) {
            window.open(pdf, '_blank');
        }
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        this.getTeleconsultations()

    }
}
</script>
<style lang="">
    
</style>